export enum REWARDS_SPENDING_RULE_TYPES {
    fixedAmount = "fixed_amount",
    percentage = "percentage",
    freeShipping = "free_shipping",
    freeProduct = "free_product",
    giftCard = "gift_card",
}

export type REWARDS_SPENDING_RULE_TYPE = `${REWARDS_SPENDING_RULE_TYPES}`;

export enum REWARDS_SPENDING_RULE_REDEEM_TYPES {
    orderDiscount = "ORDER_DISCOUNT",
    productDiscount = "PRODUCT_DISCOUNT",
    shippingDiscount = "SHIPPING_DISCOUNT",
    giftCard = "GIFT_CARD",
}
